/**
 * Last line of defense for the headings UI (release gate 2026-10-28): if the estimate
 * heading picker or the Settings headings section throws while rendering, show `fallback`
 * in its place instead of unmounting the whole page (Download ESX, the rest of Settings).
 * Data problems are handled before this by headingsShape.ts; this catches what slips past.
 */
import { Component } from 'react';
import type { ReactNode } from 'react';

interface Props {
  fallback: ReactNode;
  children: ReactNode;
}

export default class HeadingsBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.warn('Headings UI failed to render', error);
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
